// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"filter_wrapper__qpptk","resetButton":"filter_resetButton__T_x9w","chips":"filter_chips__AU2h5"};